// extracted by mini-css-extract-plugin
export default {"pageWelcomeBar":"styles_pageWelcomeBar__HtCmW"};